import cn from "classnames";
import { useMediaQuery } from "@rshbintech.dboul/core-ui";
import { useAppSelector } from "../../../../hooks";
import { useControlContext } from "../../../control";
import { selectChatSettings, selectOperatorName } from "../../selectors";
import { ChatOperator } from "../chat-operator";
import { DICTIONARY } from "../../dictionary";
import { CloseButton } from "./buttons";
import styles from "./chat-header.module.scss";

export const ChatHeader = () => {
  // TODO раскомментить после разработки
  // const { isSearch, onSearchOpen } = useSearchContext();
  const isMobile = useMediaQuery("mobile");
  const { handleChatHide } = useControlContext();
  const { opponentLastTypingTime } = useAppSelector(selectChatSettings);
  const operatorName = useAppSelector(selectOperatorName);

  const headerStyles = cn(styles.header, {
    [styles.mobile]: isMobile,
  });

  const isOpponentTyping = Boolean(opponentLastTypingTime);
  const subtitle = isOpponentTyping
    ? DICTIONARY.OPPONENT_TYPING
    : operatorName || DICTIONARY.CHAT_SUB_TITLE;

  // TODO раскомментить после разработки
  // if (isSearch) return null;

  return (
    <header data-test-id="chat-header" className={headerStyles}>
      <ChatOperator subtitle={subtitle} />
      <div
        data-test-id="chat-header-buttons"
        className={styles["buttons-container"]}
      >
        {/* TODO раскомментить после разработки */}
        {/*<SearchButton onClick={onSearchOpen} />*/}
        <CloseButton onClose={handleChatHide} />
      </div>
    </header>
  );
};
